import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function FilterList(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
    </SvgIcon>
  );
}

export default React.memo(FilterList);



// WEBPACK FOOTER //
// ./src/icons/internals/FilterList.jsx